import { createReducer, on } from '@ngrx/store';
import * as piDataActions from '../actions/pi-data.action';
import { PiPoint } from '../../models/pi-data.model';

export interface PiDataState {
  piData: any[];
  error: any;
  selectedPiPoints: PiPoint[];
  isLoadingPiPointsByRule: boolean;
  piPointValidation: {
    isSearching: boolean;
    searchTerm: string;
    isValid: boolean;
    searchResults: string[];
    searchPerformed: boolean;
    error: any;
  };
  liveCodes: { [componentId: string]: string };
}


export const initialState: PiDataState = {
  piData: [],
  error: null,
  selectedPiPoints: [],
  isLoadingPiPointsByRule: false,
  piPointValidation: {
    isSearching: false,
    searchTerm: '',
    isValid: false,
    searchResults: [],
    searchPerformed: false,
    error: null
  },
  liveCodes: {}
};

export const PiDataReducer = createReducer(
  initialState,
  on(piDataActions.addSelectedPiPoint, (state, { piPoint }) => ({
    ...state,
    selectedPiPoints: state.selectedPiPoints.includes(piPoint)
      ? state.selectedPiPoints
      : [...state.selectedPiPoints, piPoint]
  })),
  on(piDataActions.removeSelectedPiPoint, (state, { piPoint }) => ({
    ...state,
    selectedPiPoints: state.selectedPiPoints.filter(point => point !== piPoint)
  })),
  on(piDataActions.clearSelectedPiPoints, (state) => ({
    ...state,
    selectedPiPoints: []
  })),
  on(piDataActions.setSelectedPiPoints, (state, { piPoints }) => ({
    ...state,
    selectedPiPoints: [...piPoints]
  })),
  on(piDataActions.validatePiPoint, (state, { searchTerm }) => ({
    ...state,
    piPointValidation: {
      ...state.piPointValidation,
      isSearching: true,
      searchTerm: searchTerm.toUpperCase(),
      isValid: false,
      searchResults: [],
      searchPerformed: true,
      error: null
    }
  })),
  on(piDataActions.validatePiPointSuccess, (state, { searchTerm, isValid }) => ({
    ...state,
    piPointValidation: {
      ...state.piPointValidation,
      isSearching: false,
      isValid,
      searchResults: isValid ? [searchTerm.toUpperCase()] : [],
      error: null
    }
  })),
  on(piDataActions.validatePiPointFailure, (state, { searchTerm, error }) => ({
    ...state,
    piPointValidation: {
      ...state.piPointValidation,
      isSearching: false,
      isValid: false,
      searchResults: [],
      error
    }
  })),
  on(piDataActions.resetPiPointValidation, (state) => ({
    ...state,
    piPointValidation: {
      ...state.piPointValidation,
      isSearching: false,
      searchTerm: '',
      isValid: false,
      searchResults: [],
      searchPerformed: false,
      error: null
    }
  })),
  on(piDataActions.loadPiPointsByRuleId, (state) => ({
    ...state,
    isLoadingPiPointsByRule: true,
    error: null
  })),
  on(piDataActions.loadPiPointsByRuleIdSuccess, (state, { piPoints }) => ({
    ...state,
    selectedPiPoints: piPoints,
    isLoadingPiPointsByRule: false,
    error: null
  })),
  on(piDataActions.loadPiPointsByRuleIdFailure, (state, { error }) => ({
    ...state,
    isLoadingPiPointsByRule: false,
    error
  })),
  on(piDataActions.setLiveCode, (state, { componentId, code }) => ({
    ...state,
    liveCodes: {
      ...state.liveCodes,
      [componentId]: code
    }
  }))
);
